import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text, FlatList } from 'react-native';
import ActivityIndicator from '../components/ActivityIndicator';
import { ListItem } from '../components/lists';
import connectionConfig from "../config/settings";
import configurationPost from '../config/configurationPost';
import routes from '../navigation/routes';

function ListingUsersLikePublication(props) {
    useEffect(() => {       
        getListingUserLikes()
    }, []);
    const [items, setItems] = useState([]) 
    const [loading, setLoading] = useState(false);
    const [listLikes, setListLikes] = useState(0);   // este hook es para validar si tiene seguidos el usuario 

    var profileUri =  connectionConfig.imageUrl +'/Node/fixo/imagenes/PerfilDeUsuario/'

    const getListingUserLikes = async () => {
        setLoading(true)
        //debugger
        var post_values = {
            userPublicationId  : props.route.params.userPublicationId
        }
       configurationPost.body = JSON.stringify(post_values)
       await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectListingUserLikes/', configurationPost)
       .then(response => response.json())
       .then(response => {
        setItems(response.data)
        
        if( response.data.length  ===  0 ){       
            setListLikes(1) 
        }
    
        setLoading(false)
       console.log('select regresa', response)
       })
       .catch(err =>{
       console.log('Insert fixo failed :( review internet service', err )
       })
    }
    return (
    <View style={styles.container}> 
        <ActivityIndicator visible={loading} />
        {listLikes ===  0 ?
            <FlatList
              data={items}
              keyExtractor={(items) => items.userId.toString()}                  
              renderItem={({ item, index}) => (
                <ListItem
                image={profileUri + item.userId + '_' + item.userPhoto}
                titleRol={item.userName}
                onPress={ () => {
                     props.navigation.navigate(routes.FOUND_USER, {item, index})
                     }} 
                >                       
                </ListItem>   
              )}>
            </FlatList>
            :
            <Text>
                This publication has not likes             
            </Text>   
        }
    </View>
  );
}

const styles = StyleSheet.create({
    container:{
    }
})

export default ListingUsersLikePublication;